import AudioPlayer from 'react-h5-audio-player';
import 'react-h5-audio-player/lib/styles.less';

const Player = ({ url, ...rest }) => {
  return <AudioPlayer src={url} {...rest} />;
};

export default Player;
